export const CREDIT_PACKAGES = [
  { id: "starter",    name: "Starter",    credits: 500,  priceAUD: 89,   stripePriceId: "" },
  { id: "standard",   name: "Standard",   credits: 1500, priceAUD: 239,  stripePriceId: "" },
  { id: "pro",        name: "Pro",        credits: 4000, priceAUD: 549,  stripePriceId: "" },
  { id: "business",   name: "Business",   credits: 8000, priceAUD: 999,  stripePriceId: "", popular: true },
  { id: "enterprise", name: "Enterprise", credits: 9000, priceAUD: 1299, stripePriceId: "", perSeat: true },
];
